import React, { useEffect } from "react";
import * as Yup from "yup";
import FormField from "Components/Forms/FormComponent/FormFiled";
import InputFiled from "Components/Forms/InputForm/InputField";
import TextAreaInput from "Components/Forms/TextAreaForm/TextArea";
import FileUpload from "Pages/WorkInformation/FileUpload/FileUpload";
import { useState } from "react";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";
import WorkHeaderInfo from "Pages/WorkInformation/WorkHeaderInfo/WorkHeaderInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCheckDouble,
  faPlus,
  faTrash,
  faFolderOpen
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import axiosInstance from "../../axios";
import CustomReactSelect from "Components/Forms/ReactSelect/ReactSelect";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import { useNavigate } from "react-router-dom";
import { getDownloadURL, ref, uploadBytesResumable, deleteObject } from "firebase/storage";

import { doc, getDoc, collection, addDoc, updateDoc, arrayRemove } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { FieldArray, Formik, Form } from "formik";
import SliderUploader from "Pages/WorkInformation/FileUpload/SliderUploader";
import HeaderPages from "Components/HeaderPages/HeaderPages";
import "./AllProjects.css";

const OurClinc = () => {
  const { t, i18n } = useTranslation(); // Initialize the useTranslation hook
  const [documentData, setDocumentData] = useState(null);
  const [itemsOrderr, setItemsOrder] = useState([]); // Translated options

  // FORM SUBMIT
  const validationSchema = Yup.object().shape({
    title: Yup.string().required(t("required")),
    numQuantity: Yup.string().required(t("required")),
    firstFeatue: Yup.string().required(t("required")),
    secondFeatue: Yup.string().required(t("required")),
    items: Yup.array().of(Yup.string().required(t("required"))),
  });

  const [initialValues, setInitialValues] = useState({
    title: "",
    numQuantity: "",
    firstFeatue: "",
    secondFeatue: "",

    items: [],
  });
  const [Fetchloading, setFetchloading] = useState(false);

  const handleDelete = async (index) => {
    const fileToDelete = selectedFiles[index];
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);

    setSelectedFiles(updatedFiles);

    try {
      // Extract the file path and delete from Firebase Storage if it's a firebase URL
      if (fileToDelete.downloadURL && fileToDelete.downloadURL.includes("/o/")) {
        const filePath = decodeURIComponent(fileToDelete.downloadURL.split("/o/")[1].split("?")[0]);
        const storageRef = ref(storage, filePath);
        await deleteObject(storageRef);
      }

      // Remove download URL from Firestore
      const docRef = doc(db, "OurClinc", "images"); // Document path: "OurClinic/images"
      await updateDoc(docRef, {
        urls: arrayRemove(fileToDelete.downloadURL),
      });

      toast.success(t("FileDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error(t("FileDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };


  const [City, setCity] = useState();
  const [loading, setloading] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilesError, setSelectedFilesError] = useState(false);
  const [selectedFiles2, setSelectedFiles2] = useState([]);
  const [selectedFilesError2, setSelectedFilesError2] = useState(false);
  const [SelectedCategory, setSelectedCategory] = useState();
  const [SelectedCity, setSelectedCity] = useState();
  const [SelectedCategoryError, setSelectedCategoryError] = useState();
  const [SelectedCityError, setSelectedCityError] = useState();
  const [items, setItems] = useState(["contractor", "advisor", "provider"]); // Translated options
  const type = useSelector((state) => state.auth.type);
  function generateUniqueKey() {
    const timestamp = Date.now(); // Current timestamp
    const randomString = Math.random().toString(36).substring(2, 15); // Random string
    return `${timestamp}-${randomString}`;
  }
  useEffect(() => {
    const fetchExistingImages = async () => {
      try {
        const docRef = doc(db, "OurClinc", "images"); // Document path: "OurClinic/images"
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const urls = docSnap.data().urls || [];
          console.log("Existing images:", urls);

          const existingFiles = urls.map((url, index) => ({
            file: null,
            name: `Existing Image ${index + 1}`,
            type: "image",
            preview: url,
            downloadURL: url,
          }));

          setSelectedFiles(existingFiles);
        }
      } catch (error) {
        console.error("Error fetching existing images:", error);
      }
    };

    fetchExistingImages();
  }, []);
  // OEPN AND CLOSE MODAL
  const [showModal, setShowModalSuccess] = useState(false);
  // CLOSE MODAL
  const router = useNavigate();
  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };
  // OPEN MODAL
  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  // ADD CLASS ACTIVE
  const [activeItem, setActiveItem] = useState(0);

  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const handleSubmit = async (values) => {
    console.log(values);
    setloading(true);
    try {
      const docRef = doc(db, "OurClinc", "text");
      await updateDoc(docRef,
        values
      );
      // await addDoc(collection(db, "OurClinc"), {
      //   items:['asda','dasdas','asdas']
      // });

      toast.success("Our Clinc section updated successfully");

    } catch (err) {

    }
    setloading(false)
  };
  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const docRef = doc(db, "OurClinc", "text");
        setFetchloading(true);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());
          setDocumentData(docSnap.data());
          const tempObj = {
            title: docSnap.data().title,
            numQuantity: docSnap.data().subTitle,
            firstFeatue: docSnap.data().firstFeatue,
            secondFeatue: docSnap.data().secondFeatue,

            items: docSnap.data().items,
          };
          console.log(docSnap.data().items);
          setItemsOrder(docSnap.data().items);
          setInitialValues(tempObj);
          setFetchloading(false);
        } else {
          console.log("No such document!");
        }
      } catch (err) {
      } finally {
      }
    };

    fetchDocument();
  }, []);

  return (
    <>
      <HelmetInfo titlePage={t("Edit Our Clinic Section") || "Edit Our Clinic Section"} />
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />

      <div className="project-management-request all-main our-clinic-container">
        {/* Page Breadcrumbs */}
        <HeaderPages titlePage={t("Edit Our Clinic Section") || "Edit Our Clinic Section"} />

        {/* Panel 1: Clinic Text & Details */}
        <div className="clinic-card">
          <h3 className="clinic-card-title">
            <FontAwesomeIcon icon={faCheckDouble} style={{ color: "var(--blue-main-color)" }} />
            {t("Clinic Information")}
          </h3>

          <div className="form-project-management">
            {!Fetchloading && (
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, handleChange }) => (
                  <Form>
                    <div className="clinic-form-grid">
                      <InputFiled
                        label={t("Section Title")}
                        name="title"
                        type="text"
                        placeholder=""
                        success
                        value={values.title}
                        onChange={handleChange}
                      />

                      <InputFiled
                        label={t("Section text")}
                        name="numQuantity"
                        type="text"
                        placeholder=""
                        success
                        value={values.numQuantity}
                        onChange={handleChange}
                      />

                      <InputFiled
                        label={t("first Feature")}
                        name="firstFeatue"
                        type="text"
                        placeholder=""
                        success
                        value={values.firstFeatue}
                        onChange={handleChange}
                      />

                      <InputFiled
                        label={t("second Feature")}
                        name="secondFeatue"
                        type="text"
                        placeholder=""
                        success
                        value={values.secondFeatue}
                        onChange={handleChange}
                      />

                      <div className="order-list-section">
                        <h4>{t("Order List")}</h4>
                        <FieldArray name="items">
                          {({ insert, remove, push }) => (
                            <>
                              {values.items && values.items.length > 0 &&
                                values.items.map((item, index) => (
                                  <div className="order-item-row" key={index}>
                                    <div className="input-container">
                                      <InputFiled
                                        label={`${t("Item")} ${index + 1}`}
                                        name={`items[${index}]`}
                                        type="text"
                                        placeholder=""
                                        success
                                        value={item}
                                        onChange={handleChange}
                                      />
                                    </div>
                                    <button
                                      type="button"
                                      className="btn-circle-delete"
                                      onClick={() => remove(index)}
                                      title={t("Delete Item")}
                                    >
                                      <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                  </div>
                                ))}

                              <button
                                type="button"
                                className="btn-outline-add"
                                onClick={() => push('')}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                                <span>{t("Add Item")}</span>
                              </button>
                            </>
                          )}
                        </FieldArray>
                      </div>

                      <button className="btn-save-section" type="submit">
                        {loading ? (
                          <span className="loader"></span>
                        ) : (
                          t("Save Changes") || "Save Changes"
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        </div>

        {/* Panel 2: Slider Gallery */}
        <div className="clinic-card">
          <h3 className="clinic-card-title">
            <FontAwesomeIcon icon={faCalendarAlt} style={{ color: "var(--blue-main-color)" }} />
            {t("Slider Images")}
          </h3>

          {selectedFiles.length > 0 ? (
            <div className="slider-images-grid">
              {selectedFiles.map((file, index) => (
                <div className="slider-image-item" key={index}>
                  <img
                    src={file.preview}
                    alt={file.name}
                  />
                  <div className="image-delete-overlay">
                    <button
                      type="button"
                      className="btn-overlay-delete"
                      onClick={() => handleDelete(index)}
                      title={t("Delete Image")}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted text-center py-4">{t("No slider images uploaded yet")}</p>
          )}

          <div className="mt-4">
            <SliderUploader text={"jpg/png"} title={t("Upload Slider Images") || "Upload Slider Images"} />
          </div>
        </div>
      </div>
    </>
  );
};

export default OurClinc;
